import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../common/models/Visiable";
import { FinanceState } from "../models/FinanceState";

const setMessageVisiable = (state: FinanceState, action: PayloadAction<Visiable>) => {
    state.finance.messageVisiable = action.payload.visiable;
}

export default setMessageVisiable;